import { createContext, useEffect, useState } from "react";


export const ExpiryTimeContext = createContext();
  
export const ExpiryTimeCounter = ({targetDate,children}) => {
  const [time, setTime] = useState("0h 0m 0s");

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const tg = new Date(targetDate);
      const difference = tg - now;

      if (difference <= 0) {
        clearInterval(timerId);
        setTime("0h 0m 0s");
        return;
      }

      const hours = Math.floor(difference / (1000 * 60 * 60));
      const minutes = Math.floor((difference / (1000 * 60)) % 60);
      const seconds = Math.floor((difference / 1000) % 60);

      setTime(`${hours}h ${minutes}m ${seconds}s`);
    };

    const timerId = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timerId);
  }, [targetDate]);

  return (
    <ExpiryTimeContext.Provider value={{time}}>
      {children}
    </ExpiryTimeContext.Provider>
  )
}